import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CMSApiService, CraeteEventMasterDTO } from 'features/cms/api/cms-api.service';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { createEventMaster } = CMSApiService();

export const useCreateEventMaster = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: CraeteEventMasterDTO) => {
            return createEventMaster(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: (data: any) => {
                const { ResponseMessage } = data;
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (data.ResponseStatus == 0) {
                    message.error(ResponseMessage)
                } else {
                    const updatedResponseMessage = ResponseMessage.replace("Information", "Event");
                    message.success(updatedResponseMessage);
                }

            },
        },
    );
};
